export default function scrollToDiv($el, speed = 700, placement = 'center', margin = 0) {
  const elOffset = $el.offset().top;
  const elHeight = $el.height();
  const windowHeight = jQuery(window).height();
  let offset;

  if (placement === 'center') {
      if (elHeight < windowHeight) {
          offset = elOffset - ((windowHeight / 2) - (elHeight / 2));
      } else {
          offset = elOffset;
      }
  } else if (placement === 'top') {
      offset = elOffset - 50;
  }

  offset -= margin;

  jQuery('html, body').animate({ scrollTop: offset }, speed);
}
